import classnames from "classnames";
import React from "react";

import capitalise from "../utils/capitalise";
import * as styles from "./IconArrow.module.css";

const IconArrow = ({
  className,
  color,
  direction,
  center,
  scale,
  backLink,
  tail,
  lightOnDark,
}) => {
  const classes = classnames(styles.iconArrow, className, {
    [styles.center]: center,
    [styles.backLink]: backLink,
    [styles.tail]: tail,
  });

  const deg =
    (direction === "down" && "90deg") ||
    (direction === "left" && "180deg") ||
    (direction === "up" && "270deg") ||
    "0deg";
  const rotate = {
    transform: `rotate(${deg || "0"}) scale(${scale || "1"})`,
  };

  const innerClasses = classnames(
    styles.inner,
    `background${lightOnDark ? "White" : capitalise(color || "offBlack")}`
  );

  return (
    <span className={classes} style={rotate}>
      <span className={innerClasses} />
    </span>
  );
};

export default IconArrow;
